/** 시스템 설정 notifications — 알림 탭 / API */

export interface SystemNotificationSettings {
  email_notifications: boolean;
  sms_notifications: boolean;
  alert_threshold: number;
  notification_interval: number;
  safety_channel_sms: boolean;
  safety_channel_kakao: boolean;
  safety_channel_wearable: boolean;
  /** 이벤트 전송 시 캡처+메시지 합성 JPEG */
  event_share_image_enabled: boolean;
  /** 카카오톡 PC UI 자동화 보내기(테스트) */
  kakao_bot_send_enabled: boolean;
}

export const DEFAULT_SYSTEM_NOTIFICATION_SETTINGS: SystemNotificationSettings = {
  email_notifications: true,
  sms_notifications: true,
  alert_threshold: 80,
  notification_interval: 5,
  safety_channel_sms: true,
  safety_channel_kakao: false,
  safety_channel_wearable: true,
  event_share_image_enabled: true,
  kakao_bot_send_enabled: false,
};

export function mergeSystemNotificationSettings(
  partial?: Partial<SystemNotificationSettings> | null
): SystemNotificationSettings {
  const p = partial || {};
  const d = DEFAULT_SYSTEM_NOTIFICATION_SETTINGS;
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  const num = (v: unknown, fallback: number) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };
  return {
    email_notifications: bool(p.email_notifications, d.email_notifications),
    sms_notifications: bool(p.sms_notifications, d.sms_notifications),
    alert_threshold: num(p.alert_threshold, d.alert_threshold),
    notification_interval: num(p.notification_interval, d.notification_interval),
    safety_channel_sms: bool(p.safety_channel_sms, d.safety_channel_sms),
    safety_channel_kakao: bool(p.safety_channel_kakao, d.safety_channel_kakao),
    safety_channel_wearable: bool(p.safety_channel_wearable, d.safety_channel_wearable),
    event_share_image_enabled: bool(
      p.event_share_image_enabled,
      d.event_share_image_enabled
    ),
    kakao_bot_send_enabled: bool(p.kakao_bot_send_enabled, d.kakao_bot_send_enabled),
  };
}
